import React, { Suspense, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { isMobile } from 'react-device-detect';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import { InvoiceModel, InvoiceStatus } from 'models/InvoiceModel';
import InvoiceForm from 'modules/invoices/common/InvoiceForm';
import InvoiceView from 'modules/invoices/common/InvoiceView';
import useInvoices from 'modules/invoices/hooks/useInvoices';
import useInvoiceModals from 'modules/invoices/hooks/useInvoiceModals';
import auth from 'recoil/atoms/auth';


const InvoiceInner = () => {
    const my = useRecoilValue(auth);
    const {id} = useParams();
    const navigate = useNavigate();
    const modals = useInvoiceModals();
    const {getInvoice} = useInvoices();
    const [invoice, setInvoice] = useState<InvoiceModel>();

    const load = () => {
        getInvoice(Number(id))
            .then(data => setInvoice(data.data))
            .catch(() => navigate('/invoices'));
    };

    useEffect(load, [getInvoice, id, navigate]);

    if (!invoice)
        return null;

    const confirm = () => modals.openInvoiceConfirmationModal(invoice, [])
        .then(load);

    const remove = my.permissions.has('invoices delete') && invoice.status === InvoiceStatus.Unpaid ?
        () => modals.confirmDeleteInvoice(invoice)
            .then(() => navigate('/invoices')) :
        undefined;

    const save = () => {

    };

    return (
        <Container maxWidth="md" disableGutters={isMobile}>
            {my.permissions.has('invoices update') && invoice.status !== InvoiceStatus.Paid ?
                <InvoiceForm
                    invoice={invoice}
                    confirm={confirm}
                    remove={remove}
                    update={setInvoice}
                    save={save}
                    load={load}
                /> :
                <InvoiceView invoice={invoice}/>
            }
        </Container>
    );
};

const Invoice = () => {
    return (
        <Suspense fallback={null}>
            <InvoiceInner/>
        </Suspense>
    )
};

export default Invoice;
